import { changePasswordScreenSelector } from '@cmg/e2e-selectors';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import type { ChangePassword } from '../../../../../types/domain/self/ChangePassword';
import {
  changePassword,
  resetState,
  selectError,
  selectSubmitting,
} from '../../../change-password/ducks';
import { ChangePasswordDialog } from './ChangePasswordDialog';

const mapStateToProps = state => ({
  error: selectError(state),
  submitting: selectSubmitting(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      changePassword,
      resetState,
    },
    dispatch
  ),
});

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = StateProps & DispatchProps;

export const ChangePasswordRoute: React.FC<Props> = ({ actions, submitting, error }) => {
  const navigate = useNavigate();

  useEffect(() => {
    return () => {
      actions.resetState();
    };
  }, [actions]);

  const handleChangePassword = (changePassword: ChangePassword) => {
    actions.changePassword(
      {
        oldPassword: changePassword.oldPassword,
        newPassword: changePassword.newPassword,
        confirmPassword: changePassword.confirmPassword,
      },
      navigate
    );
  };

  const onCancel = () => {
    navigate(-1);
  };

  return (
    <div data-testid={changePasswordScreenSelector.testId}>
      <ChangePasswordDialog
        isSubmitting={submitting}
        error={error}
        onCancel={onCancel}
        onSubmit={handleChangePassword}
      />
    </div>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(ChangePasswordRoute);
